"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _reactSmoothCollapse = _interopRequireDefault(require("react-smooth-collapse"));

var _emotion = require("emotion");

var Accordion = function Accordion(props) {
  var customOpen = props.customOpen,
      defaultOpen = props.defaultOpen,
      onClose = props.onClose,
      title = props.title,
      children = props.children,
      style = props.style,
      headerStyle = props.headerStyle,
      bodyStyle = props.bodyStyle,
      className = props.className,
      onHeaderClick = props.onHeaderClick,
      variant = props.variant;
  var initialOpen = customOpen || defaultOpen;

  var _useState = (0, _react.useState)(initialOpen),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!open) {
      onClose && onClose();
    }
  }, [onClose, open]);

  var onLocalHeaderClick = function onLocalHeaderClick(event) {
    setOpen(function (prevOpen) {
      onHeaderClick(event, !prevOpen);
      return !prevOpen;
    });
  };

  (0, _react.useEffect)(function () {
    setOpen(customOpen || defaultOpen);
  }, [customOpen, defaultOpen]);
  return _react["default"].createElement("div", {
    className: (0, _emotion.cx)('accordion', className, {
      'accordion-open': open,
      'accordion-ghost': variant === 'ghost',
      'accordion-minimal': variant === 'minimal'
    }),
    style: style
  }, _react["default"].createElement("div", {
    className: "accordion-header",
    onClick: onLocalHeaderClick,
    style: headerStyle
  }, _react["default"].createElement("div", {
    className: "accordion-arrow"
  }, _react["default"].createElement("i", {
    className: (0, _emotion.cx)('fa', 'fa-lg', {
      'fa-angle-down': open,
      'fa-angle-right': !open
    })
  })), title), _react["default"].createElement(_reactSmoothCollapse["default"], {
    expanded: open
  }, _react["default"].createElement("div", {
    className: "accordion-body",
    style: bodyStyle
  }, children)));
};

Accordion.propTypes = {
  children: _propTypes["default"].node,
  title: _propTypes["default"].node,
  defaultOpen: _propTypes["default"].bool,
  customOpen: _propTypes["default"].bool,
  style: _reactStyleProptype["default"],
  headerStyle: _reactStyleProptype["default"],
  bodyStyle: _reactStyleProptype["default"],
  className: _propTypes["default"].string,
  onHeaderClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  variant: _propTypes["default"].oneOf(['default', 'ghost', 'minimal'])
};
Accordion.defaultProps = {
  defaultOpen: false,
  onHeaderClick: function onHeaderClick() {
    return undefined;
  },
  style: {},
  headerStyle: {},
  bodyStyle: {},
  className: '',
  variant: 'default'
};
var _default = Accordion;
exports["default"] = _default;